// extracted by mini-css-extract-plugin
module.exports = {"heading":"Wishlist_heading__3-eKc"};